import React from 'react'

import {
  Icon,
  Dollar,
  Payment,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { node, string } from 'prop-types'

import CalendarDollarIcon from 'Pods/Shared/Icons/CalendarDollarIcon'
import CalendarEventIcon from 'Pods/Shared/Icons/CalendarEventIcon'

const ICON_MAP = {
  billingCycle: CalendarDollarIcon,
  renewsOn: CalendarEventIcon,
  price: Dollar,
  payment: Payment,
}

function BillingInfoItem({ iconType, label, value, action = null }) {
  const IconComponent = ICON_MAP[iconType]

  return (
    <div className="billing-info-item">
      {IconComponent && (
        <Icon svgComponent={IconComponent} color="dark" size="small" className="gt-mr-0" />
      )}
      <span className="cgt-text-medium billing-info-item__label">{label}:</span>
      <span className="cgt-text-medium cgt-text-medium--semi-bold billing-info-item__value">{value}</span>
      {action}
    </div>
  )
}

BillingInfoItem.propTypes = {
  iconType: string.isRequired,
  label: string.isRequired,
  value: string.isRequired,
  action: node,
}

export default BillingInfoItem
